import { createAction, handleActions } from 'redux-actions';

// 타입 정의
export const SELECT_CHANNEL = 'SELECT_CHANNEL';
export const SET_TRADE_REGISTERED = 'SET_TRADE_REGISTERED';

// 액션 내보내기
export const selectChannel = createAction(SELECT_CHANNEL, channel => channel);
export const setTradeRegistered = createAction(SET_TRADE_REGISTERED);

// 초기 상태값
const initialState = {
  nowChannel: 'ticker',
  tradeRegistered: false
};

// 리듀서 내보내기
export default handleActions(
  {
    [SELECT_CHANNEL]: (state, { payload }) => {
      return {
        ...state,
        nowChannel: payload
      };
    },
    [SET_TRADE_REGISTERED]: (state, { payload }) => {
      return {
        ...state,
        tradeRegistered: payload
      };
    }
  },
  initialState
);
